import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import one from '../wasteImages/naam.png';
import two from '../wasteImages/Picture1.png';
import three from '../wasteImages/Picture2.png';
import four from '../wasteImages/Picture3.png';
import five from '../wasteImages/Picture4.png';
import six from '../wasteImages/img6.jpg';
import seven from '../wasteImages/img7.jpg';
import eith from '../wasteImages/img8.jpg';
import nine from '../wasteImages/img9.jpg';
import ten from '../wasteImages/img10.png';
import text from '../wasteImages/text.png';
import { Col, Divider, Grid, Row, Stack } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import ugr from '../../UGRoute';

export default function HomePage() {
  const navigate = useNavigate();
  return (
    <div style={{ margin: '20px 0' }}>
      <section>
        <img src={one} alt="" style={{ width: '100%', height: '100%' }} />
      </section>
      <section style={{ padding: '10px 50px' }}>
        <div style={{ textAlign: 'center' }}>
          <img src={text} alt="" style={{ width: '100%', height: '100%' }} />
        </div>
        <Swiper
          spaceBetween={30}
          effect={'fade'}
          navigation={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false
          }}
          pagination={{
            clickable: true
          }}
          modules={[EffectFade, Navigation, Pagination, Autoplay]}
          className="mySwiper-home"
        >
          <SwiperSlide>
            <img src={two} style={{ width: '100%', height: '100%' }} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={three} style={{ width: '100%', height: '100%' }} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={four} style={{ width: '100%', height: '100%' }} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={five} style={{ width: '100%', height: '100%' }} />
          </SwiperSlide>
        </Swiper>
      </section>
      {/* <div className="header-1">
        <div>
          <svg
            className="waves"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shape-rendering="auto"
          >
            <defs>
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgb(65, 184, 131)" />
              <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="#00000081" />
              <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
            </g>
          </svg>
        </div>
      </div> */}
      <section style={{ padding: '10px 50px' }}>
        {/* <div style={{ textAlign: 'end' }}>
          <button
            style={{
              outline: 'none',
              border: 'none',
              textDecoration: 'underline',
              background: 'transparent',
              color: '#005c80',
              letterSpacing: '.5px'
            }}
            onClick={() => navigate(`/${ugr}/client/collection`)}
          >
            See all
          </button>
        </div> */}
        <img src={eith} style={{ width: '100%', height: '100%' }} />

        {/* <Swiper
          spaceBetween={30}
          navigation={true}
          slidesPerView={window.innerWidth <= 764 ? 1 : 4}
          pagination={{
            clickable: true
          }}
          modules={[Navigation, Pagination]}
          className="mySwipe"
          style={{ padding: '0 0 50px 0' }}
        >
          <SwiperSlide>
            <div className="collection-card">
              <div
                className="img-collection"
                style={{ width: '100%', height: '220px', overflow: 'hidden' }}
              >
                <img
                  src={one}
                  style={{
                    height: '200px',
                    width: '100%',
                    marginTop: '10px',
                    borderRadius: '10px'
                  }}
                />
              </div>
              <div className="details">
                <h6>Product : Table</h6>
                <p>Alias : 123456789</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="collection-card">
              <div className="img-collection" style={{ width: '100%', height: '220px' }}>
                <img
                  src={one}
                  style={{
                    height: '200px',
                    width: '100%',
                    marginTop: '10px',
                    borderRadius: '10px'
                  }}
                />
              </div>
              <div className="details">
                <h6>Product : Table</h6>
                <p>Alias : 123456789</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="collection-card">
              <div className="img-collection" style={{ width: '100%', height: '220px' }}>
                <img
                  src={two}
                  style={{
                    height: '200px',
                    width: '100%',
                    marginTop: '10px',
                    borderRadius: '10px'
                  }}
                />
              </div>
              <div className="details">
                <h6>Product : Table</h6>
                <p>Alias : 123456789</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="collection-card">
              <div className="img-collection" style={{ width: '100%', height: '220px' }}>
                <img
                  src={three}
                  style={{
                    height: '200px',
                    width: '100%',
                    marginTop: '10px',
                    borderRadius: '10px'
                  }}
                />
              </div>
              <div className="details">
                <h6>Product : Table</h6>
                <p>Alias : 123456789</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="collection-card">
              <div className="img-collection" style={{ width: '100%', height: '220px' }}>
                <img
                  src={four}
                  style={{
                    height: '200px',
                    width: '100%',
                    marginTop: '10px',
                    borderRadius: '10px'
                  }}
                />
              </div>
              <div className="details">
                <h6>Product : Table</h6>
                <p>Alias : 123456789</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="collection-card">
              <div className="img-collection" style={{ width: '100%', height: '220px' }}>
                <img
                  src={one}
                  style={{
                    height: '200px',
                    width: '100%',
                    marginTop: '10px',
                    borderRadius: '10px'
                  }}
                />
              </div>
              <div className="details">
                <h6>Product : Table</h6>
                <p>Alias : 123456789</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="collection-card">
              <div className="img-collection" style={{ width: '100%', height: '220px' }}>
                <img
                  src={one}
                  style={{
                    height: '200px',
                    width: '100%',
                    marginTop: '10px',
                    borderRadius: '10px'
                  }}
                />
              </div>
              <div className="details">
                <h6>Product : Table</h6>
                <p>Alias : 123456789</p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper> */}
      </section>
      <Divider />
      <section style={{ padding: '10px 50px' }}>
        <img src={nine} alt="" style={{ width: '100%', height: '100%' }} />
      </section>
      <Divider />
      <section style={{ padding: '10px 50px' }}>
        <img src={ten} alt="" style={{ width: '100%', height: '100%' }} />
      </section>
      <Divider />
      <section style={{ padding: '10px 50px' }}>
        <img src={six} alt="" style={{ width: '100%', height: '100%' }} />
      </section>
      <Divider />
      {/* <section style={{ margin: '60px 0' }}>
        <Grid fluid style={{ padding: '0 150px' }} className="two-image-banner">
          <Row>
            <Col lg={12}>
              <div className="img-1">
                <img src={five} alt="" style={{ width: '100%', height: '100%' }} />
              </div>
            </Col>
            <Col lg={12}>
              <div className="img-1">
                <img src={six} alt="" style={{ width: '100%', height: '100%' }} />
              </div>
            </Col>
          </Row>
        </Grid>
      </section> */}
      <section style={{ textAlign: 'center' }}>
        <img src={seven} style={{ width: '90%', height: '650px' }} />
      </section>
      <Stack
        className="copyright"
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '10px 20px',
          borderTop: '1px solid lightGrey',
          zIndex: 1000000000,
          background: 'white'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          <a href="https://erpdaddy.com/" target="_blank" color="#005c80">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
    </div>
  );
}
